export const events = {
  bindPageEvents(page) {
    // Shared: clear-filter button on any page that shows the filter banner
    document.querySelectorAll('[data-clear-filter]').forEach(btn =>
      btn.addEventListener('click', () => {
        window._navFilter = null;
        App.navigate(btn.getAttribute('data-clear-filter'));
      }));

    switch (page) {
      case 'ai-assets':
        document.getElementById('btn-add-asset')?.addEventListener('click', () => this.showAssetForm());
        // Delegated listener for the View button + asset name link on each row
        document.querySelectorAll('[data-view-asset]').forEach(el => {
          el.addEventListener('click', (ev) => {
            ev.preventDefault();
            this.viewAsset(el.getAttribute('data-view-asset'));
          });
        });
        break;
      case 'asset-detail':
        if (this.assetDetailInit) this.assetDetailInit();
        break;
      case 'risk-assessments':
        document.getElementById('btn-add-risk')?.addEventListener('click', () => this.showRiskForm());
        document.querySelectorAll('[data-approve-risk]').forEach(btn =>
          btn.addEventListener('click', () => this.showApproveRiskForm(
            btn.getAttribute('data-approve-risk'),
            btn.getAttribute('data-risk-tier'),
          )));
        document.querySelectorAll('[data-reject-risk]').forEach(btn =>
          btn.addEventListener('click', () => this.showRejectRiskForm(btn.getAttribute('data-reject-risk'))));
        break;
      case 'vendors':
        document.getElementById('btn-add-vendor')?.addEventListener('click', () => this.showVendorForm());
        break;
      case 'maturity':
        document.getElementById('btn-add-maturity')?.addEventListener('click', () => this.showMaturityForm());
        break;
      case 'incidents':
        document.getElementById('btn-add-incident')?.addEventListener('click', () => this.showIncidentForm());
        break;
      case 'impact-assessments':
        document.getElementById('btn-add-aia')?.addEventListener('click', () => this.showImpactForm());
        break;
      case 'users':
        document.getElementById('btn-add-user')?.addEventListener('click', () => this.showUserForm());
        break;
      case 'support':
        document.getElementById('btn-add-ticket')?.addEventListener('click', () => this.showTicketForm());
        break;
      case 'feature-requests':
        document.getElementById('btn-add-feature')?.addEventListener('click', () => this.showFeatureForm());
        break;
    }
  },
};
